import { render } from "./CategoryManageCreateForm.vue?vue&type=template&id=0ab1103e&lang=true"
import script from "./CategoryManageCreateForm.vue?vue&type=script&lang=js"
export * from "./CategoryManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__